import script from "./CertificatesGeneratedView.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificatesGeneratedView.vue?vue&type=script&setup=true&lang=js"

import "./CertificatesGeneratedView.vue?vue&type=style&index=0&id=988c7b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-988c7b50"]])

export default __exports__